import {
  Badge,
  Box,
  ClickAwayListener,
  Grid,
  IconButton,
  Popper,
  useTheme,
} from '@mui/material'
import { NotificationsOutlined as NotificationsIcon } from '@mui/icons-material'
import {
  bindPopper,
  bindToggle,
  usePopupState,
} from 'material-ui-popup-state/hooks'
import { useHistory } from 'react-router-dom'
import { useRef } from 'react'

import { useBadgesCount } from 'contexts'
import { ROUTES_PATHS } from 'core/routes'
import { Notifications } from 'pages'

type Props = {
  notificationsCount: number | null
  redirectToPage?: boolean
  isMobile?: boolean
}

export default function TopbarNotifications({
  notificationsCount,
  redirectToPage,
  isMobile,
}: Props) {
  const theme: any = useTheme()
  const history = useHistory()
  const { fetchBadgesCount } = useBadgesCount()!
  const popperContentRef = useRef<HTMLDivElement | null>(null)

  const notificationsMenuState = usePopupState({
    variant: 'popper',
    popupId: `notificationsMenu`,
  })

  return (
    <Grid item sx={{ mr: 1 }}>
      <IconButton
        type="button"
        {...(redirectToPage && {
          onClick: () => history.push(ROUTES_PATHS.notifications),
        })}
        {...(!redirectToPage && {
          ...bindToggle(notificationsMenuState),
        })}
        sx={{
          padding: isMobile ? 0.5 : 1,
        }}
      >
        <Badge badgeContent={notificationsCount} color="error">
          <NotificationsIcon
            style={{
              fontSize: isMobile ? 30 : 32,
              color: theme.palette.text.secondary,
              cursor: 'pointer',
            }}
          />
        </Badge>
      </IconButton>

      <ClickAwayListener
        disableReactTree
        onClickAway={(event) => {
          if (!notificationsMenuState.isOpen) return
          const anchor = notificationsMenuState.anchorEl as HTMLElement | null
          if (anchor && anchor.contains(event.target as Node)) return
          if (popperContentRef.current?.contains(event.target as Node)) return
          notificationsMenuState.close()
        }}
      >
        <Popper
          style={{
            zIndex: 1201,
            width: 360,
            marginTop: '-4px',
          }}
          {...bindPopper(notificationsMenuState)}
        >
          <Box ref={popperContentRef}>
            <Notifications
              fetchBadgesCount={fetchBadgesCount}
              notificationsMenuState={notificationsMenuState}
            />
          </Box>
        </Popper>
      </ClickAwayListener>
    </Grid>
  )
}
